/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React__default from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash.omit';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const TableRow = props => {
  const prefix = usePrefix();
  let rowHasSlug;
  if (props?.children) {
    React__default.Children.toArray(props.children).map(child => {
      if (child.type?.displayName === 'TableSlugRow') {
        if (child.props.slug) {
          rowHasSlug = true;
        }
      }
    });
  }
  // Remove unnecessary props if provided to this component, these are
  // only useful in `TableExpandRow`
  const className = cx(props.className, {
    [`${prefix}--data-table--selected`]: props.isSelected,
    [`${prefix}--data-table--slug-row`]: rowHasSlug
  });
  const cleanProps = {
    ...omit(props, ['ariaLabel', 'aria-label', 'aria-controls', 'onExpand', 'isExpanded', 'isSelected']),
    className: className || undefined
  };
  return /*#__PURE__*/React__default.createElement("tr", cleanProps);
};
TableRow.propTypes = {
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * Specify if the row is selected
   */
  isSelected: PropTypes.bool
};

export { TableRow as default };
